<ng-container [formGroup]="form" *transloco="let t; prefix: 'loan-eligibility.personalInfo'">
    <ng-container formGroupName="personalInfo">
        <div class="flex flex-col gap-8 max-w-[800px] mx-auto">
            <div class="mb-10 text-center">
                <h3 class="text-black rfs:text-3xl mb-5">{{t('title')}}</h3>
                <p class="text-gray-900">{{t('description')}}</p>
            </div>
            <div class="flex flex-col gap-4">
                <div class="text-black flex flex-row items-center font-semibold gap-4">
                    <div class="text-gray-950 font-semibold">{{t('nbg-client')}}<span class="text-error"> *</span></div>
                </div>
                <div class="flex gap-4">
                    <label role="button" for="radio-is-nbg-customer-1" class="wizard-selection-item">
                        <input [formControlName]="'isNbgCustomer'" [value]="true" type="radio"
                            class="hidden" id="radio-is-nbg-customer-1">
                        <div class="wizard-selection-content min-w-[80px]">
                            <span class="wizard-selection-text font-semibold">{{t('yes')}}</span>
                        </div>
                    </label>
                    <label role="button" for="radio-is-nbg-customer-2" class="wizard-selection-item">
                        <input [formControlName]="'isNbgCustomer'" [value]="false" type="radio"
                            class="hidden" id="radio-is-nbg-customer-2">
                        <div class="wizard-selection-content min-w-[80px]">
                            <span class="wizard-selection-text font-semibold">{{t('no')}}</span>
                        </div>
                    </label>
                </div>
                <span *ngIf="hasError('isNbgCustomer')" class="text-error">{{ 'shared.error.requiredField' | transloco
                    }}</span>
            </div>
            <fieldset class="flex flex-col gap-2 group/input">
                <label tooltip="'this is my tooltip'"
                    class="font-semibold flex items-center gap-4 text-black group-disabled:text-gray-300">
                    <div class="text-gray-950 font-semibold">{{t('birth-year')}}<span class="text-error">*</span></div>
                </label>
                <div
                    class="border border-gray-300 rounded-full bg-white overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none max-w-[385px]">
                    <span class="text-gray-900 font-semibold">{{t('year')}}</span>
                    <input [formControlName]="'yearBorn'" mask="9999"
                        class="text-gray-500 flex-1 outline-none">
                </div>
                <span *ngIf="hasError('yearBorn')" class="text-error">{{ 'shared.error.requiredField' | transloco
                    }}</span>
                <div
                    class="py-[11px] px-4 flex flex-row items-center gap-6 rounded-s text-gray-900 text-sm">
                    {{t('loan-payment')}} </div>
            </fieldset>
            <div class="flex flex-col gap-4">
                <div class="text-black flex flex-row items-center font-semibold gap-4">
                    <div class="text-gray-950 font-semibold">{{t('family-status')}}<span class="text-error">*</span></div>
                </div>
                <div class="flex flex-wrap gap-4">
                    <label role="button" for="radio-marriage-status-1" class="wizard-selection-item">
                        <input [formControlName]="'marriageStatus'" [value]="'single'" type="radio"
                            class="hidden" id="radio-marriage-status-1">
                        <div class="wizard-selection-content">
                            <span class="wizard-selection-text font-semibold">{{t('single')}}</span>
                        </div>
                    </label>
                    <label role="button" for="radio-marriage-status-2" class="wizard-selection-item">
                        <input [formControlName]="'marriageStatus'" [value]="'married'" type="radio"
                            class="hidden" id="radio-marriage-status-2">
                        <div class="wizard-selection-content">
                            <span class="wizard-selection-text font-semibold">{{t('married')}}</span>
                        </div>
                    </label>
                    <label role="button" for="radio-marriage-status-3" class="wizard-selection-item">
                        <input [formControlName]="'marriageStatus'" [value]="'cohabitation'"
                            type="radio" class="hidden" id="radio-marriage-status-3">
                        <div class="wizard-selection-content">
                            <span class="wizard-selection-text font-semibold">{{t('cohabitation')}}</span>
                        </div>
                    </label>
                </div>
                <span *ngIf="hasError('marriageStatus')" class="text-error">{{ 'shared.error.requiredField' | transloco
                    }}</span>
            </div>
            <div class="flex flex-col gap-4 mb-[4.5rem]">
                <div class="text-black flex flex-row items-center font-semibold gap-4">
                    <div class="text-gray-950 font-semibold">{{t('children')}}<span class="text-error">*</span></div>
                </div>
                <div class="flex flex-wrap gap-1 sm:gap-4">
                    <label role="button" for="radio-children-0" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'0'" type="radio" class="hidden"
                            id="radio-children-0">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">0</span>
                        </div>
                    </label>
                    <label role="button" for="radio-children-1" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'1'" type="radio"
                            class="hidden" id="radio-children-1">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">1</span>
                        </div>
                    </label>
                    <label role="button" for="radio-children-2" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'2'" type="radio"
                            class="hidden" id="radio-children-2">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">2</span>
                        </div>
                    </label>
                    <label role="button" for="radio-children-3" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'3'" type="radio"
                            class="hidden" id="radio-children-3">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">3</span>
                        </div>
                    </label>
                    <label role="button" for="radio-children-4" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'4'" type="radio"
                            class="hidden" id="radio-children-4">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">4</span>
                        </div>
                    </label>
                    <label role="button" for="radio-children-5" class="wizard-selection-item">
                        <input [formControlName]="'children'" [value]="'5+'" type="radio"
                            class="hidden" id="radio-children-5">
                        <div class="wizard-selection-content min-w-[53px] sm:min-w-[56px]">
                            <span class="wizard-selection-text font-semibold">5+</span>
                        </div>
                    </label>
                </div>
                <span *ngIf="hasError('children')" class="text-error">{{ 'shared.error.requiredField' | transloco
                    }}</span>
            </div>
            <p class="text-900 text-sm">{{t('warning')}}</p>
        </div>
    </ng-container>
</ng-container>